import { useMemo } from "react";
import { ContentfulFooterNavigation, Disclaimer, DisclaimerType } from "../types";
import { Disclaimer as DisclaimerData } from "@/data/footer-disclaimer";

export const useGetDisclaimer = (type: DisclaimerType): { disclaimer: string[] | undefined } => {
  const disclaimer = useMemo(() => {
    const data = DisclaimerData as ContentfulFooterNavigation;
    if (!data) return undefined;

    let selectedDisclaimer: Disclaimer | undefined;
    const key = `disclaimerType${type}`;

    selectedDisclaimer = data[key as keyof ContentfulFooterNavigation] || data.disclaimerTypeA;

    return selectedDisclaimer?.content;
  }, [type]);
  return { disclaimer };
};
